import { isObj, isStr } from 'lib/util'
import objectHash from 'object-hash'

export const hash = object => (isObj(object) ? objectHash(object) : '')
export const lowercase = string => (isStr(string) ? string.toLowerCase() : '')
export const now = () => new Date().toISOString()
